import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./definition-list-term.css?inline";

@customElement("eko-definition-list-term")
class DefinitionListTerm extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<dt part="root" class="eko-definition-list__term"><slot></slot></dt>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-definition-list-term": DefinitionListTerm;
  }
}

export default DefinitionListTerm;
